// extracted by mini-css-extract-plugin
export var articleList = "horseSlide-module--article-list--imqel";
export var horse_list = "horseSlide-module--horse_list---EqOj";
export var horse_slide_container = "horseSlide-module--horse_slide_container--oVp8b";
export var link = "horseSlide-module--link--uz7CY";
export var meta = "horseSlide-module--meta--Qco0K";
export var title = "horseSlide-module--title--wtvCR";